import request from "@/utils/request";
//文件上传
export function uploadFileNew(data = {}) {
  return request({
    url: "file/uploadFileNew",
    method: "post",
    data,
  });
}
